export enum BusinessPartnerDoctorsManagementRoutes {
  List = '',
  Register = 'register',
  Details = ':partnerDoctorId',
}
